import React, {FC} from 'react';

import {useInitialEffect} from '../../../../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {CommentUnfurlErrorsEnum} from '../../../../../models/api/commentUnfurlModel';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../../../services/tracking';
import {CellsContext} from '../../../../../store/panels/cells/context/cellsContext';
import {NewPanelId} from '../../../../../store/panels/panelStateBase';
import {ConversationCellContainer} from '../../../cells/conversationCellContainer';
import {CommentViewerBaseUnfurl} from './commentViewerBaseUnfurl';

/*
 * Props.
 */

interface CommentViewerConversationUnfurlProps {
  panelId: NewPanelId;
  conversationId: number;
  unfurledConversation?: ConversationModel;
  unfurledActivityId?: number;
  unfurlError?: CommentUnfurlErrorsEnum;
  cellsContext: CellsContext;
  onUnfurlClick: Handler;
  isInteractionDisabled?: boolean;
}

/*
 * Component.
 */

export const CommentViewerConversationUnfurl: FC<CommentViewerConversationUnfurlProps> = (props) => {
  useInitialEffect(() => {
    trackInterfaceEvent(InterfaceEventsEnum.P3_CONVERSATION_PREVIEW_VIEW, {
      conversation_id: props.conversationId,
      unfurled_conversation_id: props.unfurledConversation?.id,
      unfurled_activity_id: props.unfurledActivityId,
      error: props.unfurlError,
    });
  });

  if (!props.unfurledConversation) {
    return null;
  }

  return (
    <CommentViewerBaseUnfurl
      onUnfurlClick={props.onUnfurlClick}
      interactionId="commentViewerUnfurl"
      isInteractionDisabled={props.isInteractionDisabled}
    >
      {renderUnfurlContents(props.panelId, props.unfurledConversation, props.cellsContext)}
    </CommentViewerBaseUnfurl>
  );
};

/*
 * Helpers.
 */

function renderUnfurlContents(
  panelId: NewPanelId,
  conversation: ConversationModel,
  cellsContext: CellsContext,
) {
  return (
    <ConversationCellContainer
      panelId={panelId}
      conversation={conversation}
      cellsContext={cellsContext}
      isExtraConversation={false}
      parameters={undefined}
      isPreview
    />
  );
}
